export enum StakingMovementLocators {
	statusField = 'statusField',
	tickerField = 'tickerField',
	directionField = 'directionField',
	createdAtField = 'createdAtField',
	destinationField = 'destinationField',
	termField = 'termField',
	applyFiltersButton = 'applyFiltersButton',
	clearFiltersButton = 'clearFiltersButton',
}
